import { IonButtons, IonHeader, IonTitle, IonToolbar, IonIcon, IonButton, IonBackButton, IonPopover, useIonViewWillLeave } from '@ionic/react';
import React, { useState } from 'react';
import './PageHeader.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { ellipsisVertical } from 'ionicons/icons';

interface IPageHeaderProps extends IRouteInfo {
    showBackButton?: boolean,
    menuContents?: JSX.Element[] | JSX.Element,
    menuIcon?: string,
    menuSrc?: string,
    navLink?: string,
}

const PageHeader: React.FC<IPageHeaderProps> = (props) => {
    const [showPageHeaderMenu, setShowPageHeaderMenu] = useState(false);
    const [pageHeaderMenuEvent, setPageHeaderMenuEvent] = useState<Event | undefined>(undefined);

    useIonViewWillLeave(() => {
        setShowPageHeaderMenu(false); 
        setPageHeaderMenuEvent(undefined);
    });

    return (
        <IonHeader mode='ios'>
            <IonToolbar color={props.themeColorName ? props.themeColorName : 'primary'}>
            { props.showBackButton ?
                <IonButtons slot="start">
                <IonBackButton text="" defaultHref="/" />
                </IonButtons> : ''
            }
            <IonTitle className="page-header-title">
                { 
                    props.SvgIcon ?
                        <props.SvgIcon className="color-white page-header-svg-icon" /> :
                    props.icon ?
                        <IonIcon className="page-header-icon" icon={props.icon} ></IonIcon> : ''
                }
                {props.title}
            </IonTitle>
            { props.menuContents ?
                <IonButtons slot="end">
                    <IonButton onClick={e => {
                        setShowPageHeaderMenu(true);
                        setPageHeaderMenuEvent(e.nativeEvent);
                    }} >
                        <IonIcon slot="icon-only" icon={props.menuIcon ? props.menuIcon : ellipsisVertical} />
                    </IonButton> 
                </IonButtons> : (props.navLink && (props.menuIcon || props.menuSrc)) ?
                <IonButtons slot="end">
                    <IonButton routerLink={props.navLink} >
                        <IonIcon slot="icon-only" icon={props.menuIcon} src={props.menuSrc}/>
                    </IonButton> 
                </IonButtons> : null
            }
            </IonToolbar>
            <IonPopover
                mode="md"
                dismissOnSelect={true}
                isOpen={showPageHeaderMenu}
                event={pageHeaderMenuEvent}
                onDidDismiss={() => {
                    setShowPageHeaderMenu(false); 
                    setPageHeaderMenuEvent(undefined);
                }}
            > {props.menuContents}</IonPopover>
        </IonHeader>
    );
};

export default PageHeader;